import { thanksgivingPromo, isPromoActive } from '../data/promo'

export const SMS_NUMBER = '+18329200133'

export interface EstimateDetails {
  name: string
  phone: string
  email?: string
  zip: string
  service?: string
  timeline?: string
  contactMethod?: string
  details?: string
}

export function buildEstimateMessage(values: EstimateDetails) {
  return [
    'Free estimate request — A&J Pool Plaster',
    '',
    `Name: ${values.name}`,
    `Phone: ${values.phone}`,
    values.email ? `Email: ${values.email}` : null,
    `City/ZIP: ${values.zip}`,
    values.service ? `Service: ${values.service}` : null,
    values.timeline ? `Timeline: ${values.timeline}` : null,
    values.contactMethod ? `Preferred contact: ${values.contactMethod}` : null,
    values.details ? `Details: ${values.details}` : null,
    isPromoActive() ? '' : null,
    isPromoActive() ? thanksgivingPromo.messageLine : null,
  ]
    .filter((line): line is string => line !== null)
    .join('\n')
}

export function smsHrefFor(message: string) {
  return `sms:${SMS_NUMBER}?&body=${encodeURIComponent(message)}`
}

export function mailHrefFor(email: string, name: string, message: string) {
  const subject = `Free estimate request — ${name || 'New customer'}`
  return `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(
    message,
  )}`
}
